import { Save } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export const BusinessRulesPanel = () => {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);
  if (!settings) return null;
  const b = settings.business;
  const up = (key, value) => setSettings({ ...settings, business: { ...b, [key]: value } });
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings", { business: b, nocrm: { ...settings.nocrm, api_key: null } });
      setSettings(data);
      toast.success("Règles de calcul enregistrées.");
    } catch {
      toast.error("Les règles n’ont pas été enregistrées. Vérifiez les champs.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <section className="settings-section" data-testid="business-settings-section">
      <div className="section-title"><div><p className="eyebrow">RÈGLES MÉTIER</p><h2>Calcul par établissement</h2></div></div>
      <div className="form-grid">
        <label>Prix unitaire<input type="number" min="0" step="0.01" value={b.unit_price} onChange={(e) => up("unit_price", Number(e.target.value))} data-testid="unit-price-input" /></label>
        <label>Base<select value={b.price_basis} onChange={(e) => up("price_basis", e.target.value)} data-testid="price-basis-select"><option value="HT">HT</option><option value="TTC">TTC</option></select></label>
        <label>Quantité par établissement<input type="number" min="1" value={b.default_quantity} onChange={(e) => up("default_quantity", Number(e.target.value))} data-testid="default-quantity-input" /></label>
        <label>Plafond par établissement<input type="number" min="1" value={b.maximum_per_establishment} onChange={(e) => up("maximum_per_establishment", Number(e.target.value))} data-testid="maximum-quantity-input" /></label>
        <label>Périmètre<select value={b.scope} onChange={(e) => up("scope", e.target.value)} data-testid="scope-select"><option value="all">Tous les établissements</option><option value="municipal">Gérés par la commune uniquement</option></select></label>
      </div>
      <label className="check-row"><input type="checkbox" checked={b.split_mixed_school} onChange={(e) => up("split_mixed_school", e.target.checked)} data-testid="split-mixed-school-checkbox" />Compter séparément une école maternelle + élémentaire sous le même UAI</label>
      <label className="check-row"><input type="checkbox" checked={b.automatic_enrichment} onChange={(e) => up("automatic_enrichment", e.target.checked)} data-testid="automatic-enrichment-checkbox" />Automatisation de l’enrichissement active</label>
      <button type="button" className="primary-button" style={{ marginTop: 14 }} onClick={save} disabled={saving} data-testid="business-settings-save"><Save size={16} />{saving ? "Enregistrement…" : "Enregistrer les règles"}</button>
    </section>
  );
};
